import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { LoginSvg } from './svg/login';

export const LoginIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LoginSvg} {...props} />
);
